import {Types} from "../../../type/Types";

export type ShoppingParticipationPolicyValueObject = {
    id: bigint
    isDefaultValue: boolean | null,
    limitedFigure: number | null,
    firstFlagLocalTime: String | null,
    secondFlagLocalTime: String | null,
    allowedAmountMultiplier: number | null,
    createdAt: Date,
    modifiedAt: Date | null,
    deletedAt: Date | null
}

export namespace ShoppingParticipationPolicyValueObject {
    export function construct(o: any): ShoppingParticipationPolicyValueObject {
        return {
            id: BigInt(o.id),
            isDefaultValue: Types.asNull(o.isDefaultValue,Boolean),
            limitedFigure: Types.asNull(o.limitedFigure,Number),
            firstFlagLocalTime: Types.asNull(o.firstFlagLocalTime,String),
            secondFlagLocalTime: Types.asNull(o.secondFlagLocalTime,String),
            allowedAmountMultiplier: Types.asNull(o.allowedAmountMultiplier,Number),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof ShoppingParticipationPolicyValueObject, string> = {
        id: 'ID',
        isDefaultValue: '기본 값 유무',
        limitedFigure: '참여 제한 구간에서의 참여 제한 수치',
        firstFlagLocalTime: '참여 제한 시각 첫번째 플래그',
        secondFlagLocalTime: '참여 제한 시각 두번째 플래그',
        allowedAmountMultiplier: '물량 허용 배수',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
        deletedAt: '삭제 시각',
    }
}